import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const inspection: AppRouteModule = {
    path: '/inspection',
    name: 'Inspection',
    component: LAYOUT,
    meta: {
        orderNo: -30,
        icon: 'ant-design:phone-outlined',
        title: '质检管理',
    },
    children: [
        {
            path: 'inspectionWords',
            name: 'InspectionWords',
            component: () => import('/@/views/inspection/InspectionWords.vue'),
            meta: {
                title: '质检词管理',
                icon: 'ant-design:field-string-outlined'
            },
        },
        {
            path: 'inspectionManage',
            name: 'InspectionManage',
            component: () => import('/@/views/inspection/InspectionManage.vue'),
            meta: {
                title: '质检会话',
                icon: 'ant-design:safety-certificate-outlined'
            },
        }
    ],
};

export default inspection;
